import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebase";

export const CHECKOUT_DRAFT_KEY = "unlimited-session-checkout-draft";

export function isStripeCheckoutEnabled() {
  return process.env.REACT_APP_ENABLE_STRIPE === "true";
}

export async function startCheckoutSession({ orderRefs }) {
  if (!isStripeCheckoutEnabled()) {
    return false;
  }

  const functions = getFunctions(app, "europe-west1");
  const createCheckoutSession = httpsCallable(functions, "createCheckoutSession");
  const result = await createCheckoutSession({
    orderRefs: orderRefs.map(({ type, id }) => ({ type, id })),
    successUrl: `${window.location.origin}/compte?payment=success`,
    cancelUrl: `${window.location.origin}/panier?payment=cancelled`,
  });

  if (result.data?.url) {
    window.location.assign(result.data.url);
    return true;
  }

  return false;
}
